/**
 * Politica Geral de Compra e Pagamento da Empiria, versao de 22 de julho de 2026.
 * Transcricao integral do PDF aprovado -- nao reescrever nem resumir. Cada
 * bloco corresponde a um item do documento; o `id` e a numeracao original,
 * que os outros documentos citam ("item 3.4", "item L").
 */
const compraEPagamento = [
    {
        tipo: "texto",
        texto:
            "Esta Política regula todas as compras e pagamentos realizadas na Plataforma Empiria.",
    },
    {
        tipo: "texto",
        texto:
            "A Política de Compra e Pagamento integra os Termos Gerais de Uso da Empiria. Você deve ler de forma atenta e cuidadosa as condições a seguir, pois elas contêm informações importantes sobre acesso ou uso dos recursos relativos ao pagamento.",
    },
    {
        tipo: "texto",
        texto:
            "Após aceitar esta Política, a Empiria lhe concede automaticamente uma licença de uso não exclusiva do sistema de pagamento. Os recursos são licenciados no estado em que se encontram. Eles podem ser modificados, substituídos ou removidos a qualquer momento, sem aviso prévio, ressalvado o disposto na Seção 4.4 sobre alteração de taxas. Se você não concordar com uma nova versão da Política de Pagamentos, você deve cessar o uso da sua conta na Empiria. Esta Política e suas respectivas atualizações prevalecem sobre quaisquer propostas, contratos, entendimentos anteriores e acordos, verbais ou escritos, que possam existir entre você e a Empiria.",
    },
    {
        tipo: "texto",
        texto:
            "Para facilitar a leitura desta Política, oferecemos um Glossário, disponível em www.empiriapp.com.br/glossario, que relaciona o significado das expressões iniciadas por letras maiúsculas nos Termos da Empiria, bem como nesta ou em outras Políticas da Empiria.",
    },
    {
        tipo: "secao",
        texto:
            "VISÃO GERAL",
    },
    {
        tipo: "item",
        id: "A.",
        texto:
            "Esta Política regula o acesso ou uso dos recursos de compra e pagamento para todas as transações efetuadas na Plataforma Empiria.",
    },
    {
        tipo: "item",
        id: "B.",
        texto:
            "Ao aceitar esta Política, você declara que conhece e concorda com o seu conteúdo e com as demais Políticas aplicáveis, inclusive com a Política de Privacidade, que, apesar de apresentadas em textos separados, são partes integrantes dos Termos Gerais de Uso da Empiria.",
    },
    {
        tipo: "item",
        id: "C.",
        texto:
            "A Empiria pode recusar ou cancelar um pedido de compra, se identificar que o Comprador consiste em um Anfitrião comprando a partir de link próprio, ou se os dados do Comprador não estiverem preenchidos integralmente com informações reais sobre si ou ainda, se houver suspeita de algum ato ilícito.",
    },
    {
        tipo: "item",
        id: "D.",
        texto:
            "A Empiria pode recusar a aprovação de uma compra solicitada por um Comprador que já realizou mais de um pedido de reembolso pela Plataforma.",
    },
    {
        tipo: "item",
        id: "E.",
        texto:
            "Os serviços e funcionalidades disponibilizados através da Plataforma são fornecidos como eles se apresentam, sem garantias expressas ou tácitas, incluindo, entre outras, garantias de comerciabilidade, adequação a um fim específico, propriedade, não violação e proteção contra vírus de computador ou outros códigos nocivos.",
    },
    {
        tipo: "item",
        id: "F.",
        texto:
            "Qualquer informação adicional sobre o Encontro deve ser questionada pelos meios de comunicação da Empiria.",
    },
    {
        tipo: "item",
        id: "G.",
        texto:
            "A compra vai aparecer no extrato ou fatura do cartão indicando o nome da Empiria. No entanto, isso consiste numa mera identificação da Empiria como facilitadora do pagamento, seja na fatura ou extrato do cartão, e não torna a Plataforma vendedora ou responsável pelo Encontro, tampouco por sua funcionalidade, características, oferta e publicidade.",
    },
    {
        tipo: "item",
        id: "H.",
        texto:
            "O Comprador reconhece que poderá receber mais de 1 (uma) nota fiscal em decorrência de uma mesma compra na Plataforma.",
    },
    {
        tipo: "item",
        id: "I.",
        texto:
            "Para problemas e dúvidas sobre a compra, como opções de pagamento, acesso ao Produto, reembolso e assistência em geral, o Comprador deve entrar em contato com nosso suporte através do e-mail suporte@empiriapp.com.br ou pelo chat disponível na Plataforma.",
    },
    {
        tipo: "item",
        id: "J.",
        texto:
            "A Empiria é uma plataforma de geração de encontros virtuais e não tem vínculo trabalhista, empregatício ou de qualquer outra natureza com os Anfitriões, somente realiza a prestação de serviços de tecnologia e distribuição digital dos Encontros. Na forma dos Termos de Uso, a Empiria não responde pelo Produto adquirido, pois seu conteúdo, funcionalidade, qualidade, oferta e publicidade são de inteira responsabilidade do Anfitrião.",
    },
    {
        tipo: "item",
        id: "K.",
        texto:
            "Quando os Usuários realizam uma transação sobre um Encontro mediante a Plataforma, eles celebram um contrato diretamente um com o outro. A Empiria não é, e não se torna parte, interveniente ou garantidora de qualquer relação entre os Usuários. A Empiria não cria, elabora, controla, endossa ou fornece qualquer Encontro para os Usuários. Os Anfitriões são os responsáveis pelo conteúdo e pelas informações relativas aos seus Encontros, respondendo por sua existência e por suas características, qualidade, funcionalidades, quantidade, oferta e publicidade. Para a resolução de questões relacionadas especificamente ao conteúdo do Encontro adquirido, o Comprador deverá tirar dúvida com este durante a realização do encontro, ou pelos meios de contato disponibilizados pela Plataforma.",
    },
    {
        tipo: "item",
        id: "L.",
        texto:
            "Direito de arrependimento: nos termos do artigo 49 do Código de Defesa do Consumidor, o Comprador pessoa física que adquirir um Encontro fora do estabelecimento comercial (o que inclui a compra realizada pela internet) tem o direito de desistir da compra no prazo de 7 (sete) dias corridos, contados da data da contratação, sem necessidade de justificativa, desde que o Encontro ainda não tenha sido realizado nem parcialmente consumido pelo Comprador. Exercido esse direito dentro do prazo, o valor pago será integralmente devolvido, sem prejuízo do disposto na Seção 3.4 sobre solicitações de reembolso por outras razões.",
    },
    {
        tipo: "secao",
        texto:
            "1. OS SERVIÇOS PRESTADOS PELO SISTEMA DE COMPRA E PAGAMENTO",
    },
    {
        tipo: "item",
        id: "1.1.",
        texto:
            "Escopo do serviço: O sistema de pagamentos é um serviço que processa as instruções de pagamento realizadas pelos Convivas e as liquida para os Anfitriões, conforme regras e procedimentos determinados nesta Política e nos Termos da Empiria. Os recursos de pagamento possibilitam ao Usuário: (a) pagar pela compra de encontros cadastrados na Plataforma, se for Conviva; (b) receber os valores relativos à comercialização de seus Encontros, se Anfitrião.",
    },
    {
        tipo: "item",
        id: "1.2.",
        texto:
            "Inexistência de serviços de instituição financeira ou de cartão de crédito: Os recursos de pagamento não são e nem se destinam a ser comparáveis aos serviços oferecidos por instituições financeiras ou por administradoras ou credenciadoras de cartão de crédito. O sistema de pagamento integrado é apenas um facilitador de transações de pagamento entre os Usuários da Plataforma, sendo que o pagamento de transações ocorre por conta e ordem dos Usuários. A Empiria não é uma instituição financeira e não realiza operações de crédito diretamente.",
    },
    {
        tipo: "item",
        id: "1.3.",
        texto:
            "Serviços de Terceiros: As transações realizadas com Produtos cadastrados na Plataforma somente podem ser pagas mediante os recursos de pagamento. Para tanto, a Empiria pode usar meios de pagamento de terceiros e empresas parceiras para receber pagamentos, pagar valores ou adiantar recebíveis das transações (como instituições bancárias, administradoras de cartões de crédito e outras entidades de crédito). Nesses casos, podem existir termos e condições distintos que você deve cumprir. Em caso de interrupção da relação com algum Serviço de Terceiro, algum(ns) meio(s) de pagamento(s) pode(m) deixar de ser ofertado(s) na Plataforma da Empiria. A Empiria não é responsável pela disponibilidade, pela precisão ou interrupção da prestação destes Serviços de Terceiros.",
    },
    {
        tipo: "item",
        id: "1.4.",
        texto:
            "Oferecimento de Serviços de Terceiros adicionais: A Empiria pode permitir que parceiros seus (como instituições financeiras e correspondentes bancários) ofereçam seus serviços de forma agregada aos recursos de pagamento. Também nesses casos, podem existir termos e condições distintos que você deve cumprir, e a Empiria não é responsável pela disponibilidade ou pela precisão da prestação destes Serviços de Terceiros.",
    },
    {
        tipo: "item",
        id: "1.5.",
        texto:
            "Tributos e Nota Fiscal: A Empiria não é responsável pelo recolhimento dos tributos pelos quais os seus Usuários sejam os contribuintes ou responsáveis tributários. Cabe aos Usuários recolher os tributos de que sejam sujeitos passivos, na forma da legislação aplicável. As obrigações tributárias podem variar de acordo com sua situação específica, por isso recomendamos que você pesquise a respeito e consulte profissionais especializados para obter informações detalhadas.",
    },
    {
        tipo: "item",
        id: "1.6.",
        texto:
            "Emissão da nota fiscal: Cabe ao Anfitrião a correta emissão da nota fiscal correspondente aos serviços prestados aos Convivas, referente ao valor total ou parcial da venda, conforme aplicável.",
    },
    {
        tipo: "item",
        id: "1.6.1.",
        texto:
            "O Anfitrião declara estar ciente de que a Empiria irá cumprir com suas responsabilidades fiscais e realizará a comunicação às autoridades competentes sobre a venda das Reuniões geradas na Plataforma, em especial no que tange ao cumprimento de obrigações acessórias que recaem sobre intermediadores de pagamento.",
    },
    {
        tipo: "secao",
        texto:
            "2. O ACESSO AOS RECURSOS DE COMPRA E PAGAMENTO",
    },
    {
        tipo: "item",
        id: "2.1.",
        texto:
            "Acesso aos recursos: Cumpridos todos os requisitos de elegibilidade, cadastro e acesso previstos nos Termos Gerais de Uso da Empiria, no momento em que o Anfitrião se cadastrar na Plataforma, ele concorda e solicita que a Empiria: (a) receba o preço pago pelo Comprador; (b) deduza a remuneração devida à Empiria pelo uso de seus recursos; e (c) pague o valor remanescente devido ao Anfitrião na sua conta de pagamento cadastrada na Empiria.",
    },
    {
        tipo: "item",
        id: "2.2.",
        texto:
            "Acesso do Comprador ao Encontro: O prazo para o Comprador ter acesso ao Encontro pode variar de acordo com o meio de pagamento. Atualmente, as compras realizadas por cartão de crédito possuem um prazo máximo de liberação de até 24 horas, ainda que, na prática, esse prazo costume ser de poucos minutos.",
    },
    {
        tipo: "item",
        id: "2.3.",
        texto:
            "Confirmação dos dados do Usuário: Além das ações previstas nos Termos, a Empiria reserva-se o direito de utilizar todos os meios válidos para confirmar os dados fornecidos pelo Usuário para permitir o seu acesso aos recursos de pagamento.",
    },
    {
        tipo: "item",
        id: "2.4.",
        texto:
            "A Empiria também pode solicitar dados adicionais e documentos que julgar pertinentes, como informes de rendimento, atestados de titularidade de conta bancária e extratos bancários completos. A Empiria pode ainda consultar bancos de dados de caráter público ou privado e bases de dados de restrições mantidos por terceiros e bases de restrições creditícias. Ao aceitar esta Política, você autoriza a Empiria a efetuar esses procedimentos.",
    },
    {
        tipo: "item",
        id: "2.5.",
        texto:
            "Uso dos recursos de pagamento: Você se obriga a tomar todas as precauções necessárias para evitar que terceiros usem sua conta em seu nome. Você se responsabiliza pelas transações comerciais, pagamentos e movimentações financeiras feitas em seu nome por terceiros, ainda que sem sua autorização, se esses terceiros tiverem acesso, sem culpa exclusiva da Empiria, à sua senha ou a outros dados seus.",
    },
    {
        tipo: "item",
        id: "2.6.",
        texto:
            "Sigilo bancário e proteção de dados: Em cumprimento à Política de Privacidade e às demais leis aplicáveis, a Empiria não pode fornecer ao Anfitrião quaisquer dados de Compradores relacionados a transações de pagamento, a operações realizadas ou a serem realizadas por Compradores na Plataforma, mesmo em caso de exclusão do Anfitrião da Plataforma. Os dados de pagamento coletados por meio do recurso de pagamento não ficam, de forma alguma, armazenados na Plataforma, tampouco poderão ser repassados ao Produtor, que não figura como Controlador destes dados.",
    },
    {
        tipo: "item",
        id: "2.7.",
        texto:
            "As modalidades dos Encontros, da Compra e do Pagamento: O Anfitrião tem a flexibilidade de criar Encontros, definindo datas e horários específicos para a realização do encontro. Além disso, o Anfitrião deve decidir se os Encontros serão privados (em que apenas o Anfitrião e o Conviva participarão) ou públicos (em que qualquer participante da Empiria poderá participar) e selecionar entre diferentes modalidades de oferta: Agendamento, em que o pagamento é feito diretamente para acessar o Encontro, ou Sorteio, no qual os compradores adquirem o direito de concorrer ao Encontro, com chances de sucesso não garantidas e, caso não sejam sorteados, poderão assistir ao Encontro entre o Anfitrião e o selecionado.",
    },
    {
        tipo: "item",
        id: "2.7.1.",
        texto:
            "Quando a condição do Encontro, escolhida pelo Anfitrião, for Agendamento, o Anfitrião poderá escolher um dia e horário específico ou poderá disponibilizar várias opções de datas e horários para a realização de um Encontro, permitindo que o Comprador escolha um deles através da agenda da plataforma Empiria, mediante pagamento do valor estipulado para o referido Encontro. Nesse contexto, o Anfitrião pode optar por tornar o Encontro público, visível para todos os Convivas, ou privado, limitando a visibilidade ao Anfitrião e ao Comprador. Durante a criação do Encontro, o Anfitrião deve especificar antecipadamente se ele será público ou privado, e o Comprador, ao efetuar a compra, concorda com a opção de Encontro oferecida pelo Anfitrião. Nessa modalidade, a aquisição do Encontro pelo Comprador garante a sua realização.",
    },
    {
        tipo: "item",
        id: "2.7.2.",
        texto:
            "Quando o Anfitrião optar pela modalidade de sorteio, poderá criar o Encontro para um dia e horário específico ou várias opções de datas e horários para sua realização, permitindo que o selecionado do Sorteio participe do encontro escolhido, através da Agenda, ao qual concorreu. Nesse caso, obrigatoriamente, o Encontro será realizado na modalidade pública, ficando visível a todos os Convivas que adquiram o direito de participar da seleção e não foram contemplados.",
    },
    {
        tipo: "item",
        id: "2.7.3.",
        texto:
            "O sorteio será conduzido dentro da própria plataforma da Empiria, que conta com um recurso próprio e automatizado para gerar a seleção, assegurando a integridade e imparcialidade desta seleção. É importante destacar que o Anfitrião não tem permissão para utilizar plataformas de sorteio externas à Empiria, atitude que violaria os Termos de Uso e as políticas da Empiria, sujeitando-se, desta forma, às suas penalidades. O Anfitrião poderá marcar a Data e horário do Sorteio com tempo máximo de até 10min antes do encontro, momento em que caso o Anfitrião não faça o sorteio, este será realizado automaticamente.",
    },
    {
        tipo: "item",
        id: "2.7.4.",
        texto:
            "No momento da compra, o Comprador declara estar ciente do dia e horário definido pelo Anfitrião para a realização do Encontro, conforme informações constantes da sua Agenda na Empiria, bem como concorda com a modalidade pública ou privada do Encontro.",
    },
    {
        tipo: "item",
        id: "2.7.5.",
        texto:
            "Comunicação do Resultado da Seleção: Após a realização da seleção, a Empiria comunicará o resultado a todos os Convivas inscritos. Ao Conviva selecionado, a comunicação será feita por WhatsApp ou outro meio direto de comunicação cadastrado pelo Usuário, contendo o link de acesso ao Encontro na condição de participante direto. Aos demais Convivas inscritos e não selecionados, a comunicação será feita por e-mail, informando que não foram selecionados e contendo o link de acesso ao Encontro na condição de telespectador, nos termos do item 5.6 dos Termos Gerais de Uso.",
    },
    {
        tipo: "texto",
        texto:
            "Caso o Conviva inscrito não receba a comunicação do resultado da Seleção por qualquer motivo, inclusive falha de entrega do WhatsApp, do e-mail ou de outro meio de comunicação utilizado, cabe a ele acessar a Plataforma diretamente na data e horário marcados para o Encontro, onde poderá consultar o resultado da seleção e o respectivo link de acesso em sua Agenda. A ausência da referida comunicação não gera direito a reembolso ou indenização, desde que o acesso ao Encontro tenha permanecido disponível na Plataforma na data e horário marcados.",
    },
    {
        tipo: "secao",
        texto:
            "3. PROCESSAMENTO DE COMPRA E PAGAMENTO",
    },
    {
        tipo: "item",
        id: "3.1.",
        texto:
            "Confirmação de instrução de pagamento: Ao escolher realizar um pagamento por meio dos recursos de pagamento da Empiria, o Comprador deve fornecer todas as informações bancárias solicitadas para concretizá-lo. A instrução do Comprador será considerada concedida de forma irrevogável e irretratável quando a Empiria confirmar ao Comprador o recebimento, com sucesso, dos dados enviados relativos à transação, sem prejuízo do direito de arrependimento previsto na alínea L da Visão Geral desta Política.",
    },
    {
        tipo: "item",
        id: "3.2.",
        texto:
            "Realização de pagamento: Uma vez que a Empiria receber a confirmação de que a transação foi aprovada, deverá disponibilizar os valores devidos ao Anfitrião em sua conta de pagamento mantida na Plataforma, no prazo médio de até 30 (trinta) dias estipulado pela empresa responsável pela transação financeira, ressalvado que o Anfitrião pode acompanhar os valores a receber antes da efetiva liberação. Ressalvam-se, ainda, as hipóteses em que a Empiria está autorizada a suspender ou cancelar os pagamentos, na forma dos Termos e desta Política. A Empiria deve disponibilizar esses valores, observando: (a) a eventual ocorrência de estornos ou pedidos de reembolso, (b) o transcurso dos prazos de garantia ou exercício de direito de arrependimento pelo Comprador e (c) o prazo que a instituição financeira requer para realizar a transferência para o Anfitrião.",
    },
    {
        tipo: "item",
        id: "3.2.1.",
        texto:
            "A Empiria não está obrigada, em hipótese alguma, a contestar os pedidos de estorno apresentados pelos Compradores e deduzirá os valores daqueles devidos aos Anfitriões. Eventuais contestações realizadas por mera liberalidade não obrigam a Empiria em casos futuros.",
    },
    {
        tipo: "item",
        id: "3.3.",
        texto:
            "Responsabilidade do Comprador pelos dados informados: O Comprador é o único responsável por todos os atos que praticar relativos à instrução de pagamento. O Comprador deve fornecer informações verdadeiras, completas e exatas. A Empiria não é responsável por quaisquer danos, patrimoniais ou extrapatrimoniais, resultantes de qualquer falha, inveracidade ou incompletude imputável ao Comprador quando preencher as informações referentes à instrução de pagamento.",
    },
    {
        tipo: "item",
        id: "3.4.",
        texto:
            "Solicitação de reembolso: Se o Comprador realizar uma transação e se sentir lesado em relação à qualidade do Produto adquirido, ele pode enviar uma solicitação de reembolso através do suporte, dentro dos prazos de garantia ou de exercício de direito de arrependimento aplicáveis à respectiva transação, observada a legislação aplicável. A Empiria deve comunicar o Anfitrião sobre o ocorrido, que terá 5 (cinco) dias corridos para responder à reclamação de forma justificada ou sanar o problema. Se o Anfitrião não entrar em contato nesse prazo, a Empiria pode reembolsar integralmente ao Comprador os valores pagos, cujo montante deve ser deduzido do saldo da conta de pagamento do Anfitrião. Para mais informações sobre reembolsos, sugerimos conferir a Seção 11 dos Termos Gerais de Uso da Empiria.",
    },
    {
        tipo: "texto",
        texto:
            "A Empiria pode recusar o reembolso dos valores pagos, ainda que dentro do prazo de garantia ou de desistência, na hipótese de o Comprador ter usufruído de todo ou parte do Encontro adquirido, deixando a Empiria e o Anfitrião em clara desvantagem, ressalvado sempre o direito de arrependimento previsto em lei quando o Encontro ainda não tiver sido realizado. Essa é uma prerrogativa exclusiva da Empiria e não do Anfitrião. O mesmo ocorre em caso de problemas técnicos de responsabilidade do comprador, seja pela conexão de internet, seja por causa do dispositivo que utiliza para o encontro, ou quaisquer outros problemas que impossibilitem a realização do encontro.",
    },
    {
        tipo: "item",
        id: "3.4.1.",
        texto:
            "A Empiria disponibiliza o e-mail reembolso@empiriapp.com.br e o canal de atendimento pelo chat da Plataforma para as solicitações de reembolso. Os Compradores estão cientes de que esses são os únicos meios válidos para a solicitação e que não devem responder a e-mails automáticos eventualmente enviados durante o processo de aquisição de um Encontro.",
    },
    {
        tipo: "item",
        id: "3.4.2.",
        texto:
            "Forma de processamento e prazo para conclusão: O reembolso será processado através do mesmo meio de pagamento utilizado no momento da compra. O prazo para a sua conclusão é de (a) até 30 (trinta) dias, no caso de transferência bancária ou PIX; e (b) até 90 (noventa) dias, nos casos de compras realizadas por meio de cartão de crédito. A conclusão dos reembolsos por meio do cartão de crédito dependerá exclusivamente das operadoras de cartão, sem qualquer gerência da Empiria. Se o reembolso não ocorrer dentro dos prazos acima, o Comprador deve entrar em contato com a Empiria. Nos casos envolvendo cartão de crédito, o Comprador se compromete a enviar cópias de suas faturas para que a Empiria possa endereçar este assunto perante a operadora e finalizar o processo de reembolso. A recusa do envio das faturas impede que a Empiria dê seguimento ao processo de investigação e conclusão do caso. Essas regras não se aplicam ao exercício do direito de arrependimento previsto na alínea L da Visão Geral, cujo reembolso deve ser processado de forma simplificada e sem exigência de justificativa.",
    },
    {
        tipo: "item",
        id: "3.4.3.",
        texto:
            "Contestação de compras: O Comprador está ciente de que a apresentação de contestação por parte do Anfitrião impede que a Empiria realize o processamento de eventuais reembolsos fundados em insatisfação com a qualidade do Encontro enquanto o processo de contestação da compra estiver em andamento, sem prejuízo do reembolso imediato nos casos de exercício do direito de arrependimento dentro do prazo legal de 7 (sete) dias. O reembolso relativo à contestação é feito apenas após a conclusão desse processo, a depender do seu resultado.",
    },
    {
        tipo: "item",
        id: "3.5.",
        texto:
            "Colaboração da Empiria em caso de solicitação de reembolso: Os serviços referentes a disputas e reembolsos são prestados apenas para facilitar e acompanhar o processo de realização da transação de pagamento entre Comprador e Anfitrião. Assim, ao utilizar a plataforma da Empiria, você reconhece que qualquer transação de pagamento, quando efetivada, ocorre diretamente entre o Anfitrião e o Comprador. A Empiria não é parte da cadeia de fornecimento dos encontros adquiridos, não podendo ser considerada fornecedora, prestadora, agente ou corretora.",
    },
    {
        tipo: "item",
        id: "3.6.",
        texto:
            "A moeda utilizada pela Empiria: A Empiria efetua transações de pagamento apenas em moeda brasileira (BRL) para Usuários que declararam residir no Brasil.",
    },
    {
        tipo: "item",
        id: "3.7.",
        texto:
            "No que se refere ao valor mínimo aceito pela Plataforma: os valores dos Encontros devem atender ao limite mínimo de R$ 3,00 (três reais). Não há restrição quanto ao valor máximo para a disponibilização dos encontros.",
    },
    {
        tipo: "secao",
        texto:
            "4. TAXAS DO USO",
    },
    {
        tipo: "item",
        id: "4.1.",
        texto:
            "Taxa do Anfitrião: O uso dos recursos da plataforma Empiria pelo Anfitrião está sujeito ao pagamento de uma Taxa de Intermediação. Ela é cobrada apenas no momento da venda dos encontros, quando a transação é aprovada, sendo deduzida do valor final cobrado pelo Anfitrião.",
    },
    {
        tipo: "item",
        id: "4.2.",
        texto:
            "Taxa de Intermediação: O valor da Taxa de Intermediação corresponde a 50% (cinquenta por cento) do preço de venda do encontro, podendo sofrer variações com aviso prévio de 30 dias. Esta porcentagem tenderá a ser reduzida com o crescimento do número de encontros na plataforma, podendo chegar a 30% (trinta por cento).",
    },
    {
        tipo: "item",
        id: "4.3.",
        texto:
            "Base de cálculo da Taxa de Intermediação: A Taxa de Intermediação será aplicada ao valor final cobrado pelo Anfitrião de cada Comprador.",
    },
    {
        tipo: "item",
        id: "4.4.",
        texto:
            "Mudanças das Taxas: As taxas mencionadas nesta Seção, seus respectivos tipos de pagamento, meios de pagamento e faturamento podem ser alterados a qualquer tempo, a exclusivo critério da Empiria, mediante notificação prévia de 30 (trinta) dias aos Usuários.",
    },
    {
        tipo: "item",
        id: "4.5.",
        texto:
            "Autorização dos débitos referente às taxas: O Anfitrião está ciente e autoriza a Empiria a debitar as Taxas aplicáveis, conforme informado nos itens 4.2 e 4.3 acima.",
    },
    {
        tipo: "item",
        id: "4.6.",
        texto:
            "Aporte de Valores: A única maneira de inserir valores é através da realização de encontros dentro da plataforma.",
    },
    {
        tipo: "item",
        id: "4.7.",
        texto:
            "Intransferibilidade da Conta de Pagamento: A Conta de Pagamento do Anfitrião é pessoal e intransferível, sendo associada a um único Anfitrião. O Anfitrião não poderá autorizar o uso de sua Conta por terceiros.",
    },
    {
        tipo: "item",
        id: "4.8.",
        texto:
            "A transferência do valor: a transferência ficará a cargo da responsável financeira pelo recebimento, hoje a Stone. Desta forma, cabe ao Anfitrião manter uma relação financeira com a referida empresa para receber o valor respectivo do Encontro.",
    },
    {
        tipo: "item",
        id: "4.9.",
        texto:
            "Prazos de disponibilidade e liquidação das transações: Os pagamentos creditados estarão disponíveis de acordo com os prazos e condições descritas nesta Política.",
    },
    {
        tipo: "item",
        id: "4.10.",
        texto:
            "Suspeita de Fraude e Medidas de Prevenção na Conta de Pagamento: Os pagamentos efetuados poderão ser bloqueados total ou parcialmente, a critério da Empiria, conforme descrito na Seção 6 (\"Medidas de prevenção a fraudes e suspensão de pagamentos\") desta Política.",
    },
    {
        tipo: "item",
        id: "4.11.",
        texto:
            "Bloqueio de Valores na Conta de Pagamento: Os valores eventualmente bloqueados em decorrência de práticas irregulares ou das razões acima poderão ser retirados e utilizados pela Empiria para o cumprimento de ordem judicial, para o ressarcimento de eventuais custos, despesas ou danos causados à Empiria ou a terceiros.",
    },
    {
        tipo: "secao",
        texto:
            "5. PARCELAMENTO E FUNCIONALIDADES ADICIONAIS",
    },
    {
        tipo: "item",
        id: "5.1.",
        texto:
            "Funcionalidades adicionais: A Empiria pode oferecer aos Usuários funcionalidades adicionais para facilitar as transações de pagamento entre eles, tais como, entre outros: (a) a opção de disponibilizar o parcelamento do preço de oferta do Encontro. A utilização dessas funcionalidades adicionais pode implicar o pagamento de taxas extras pelo Usuário, as quais sempre serão informadas antes da ativação da funcionalidade específica.",
    },
    {
        tipo: "secao",
        texto:
            "6. MEDIDAS DE PREVENÇÃO A FRAUDES E SUSPENSÃO DE COMPRA E PAGAMENTO",
    },
    {
        tipo: "item",
        id: "6.1.",
        texto:
            "Irregularidades na conta do Usuário: Devido à regulamentação aplicável, a Empiria pode precisar realizar verificações nos dados fornecidos pelos Usuários antes de autorizar os pagamentos ou recebimentos. A Empiria informará os Usuários que possuírem cadastros irregulares ou incompletos. A Empiria pode bloquear qualquer operação de saque e suspender o acesso aos links de vendas do Usuário se este não efetuar os ajustes necessários no prazo de 30 dias a contar da notificação da Empiria.",
    },
    {
        tipo: "item",
        id: "6.2.",
        texto:
            "Suspeitas de fraude: Todas as transações de pagamento realizadas por meio da interface da plataforma Empiria são verificadas pelos mecanismos de gestão de risco integrados à plataforma e podem ser recusadas sempre que a Empiria identificar indícios de fraude nos métodos de pagamento, violações da lei ou dos Termos da Empiria.",
    },
    {
        tipo: "item",
        id: "6.3.",
        texto:
            "Medidas preventivas relativas a transações de pagamento: A Empiria pode recusar a aprovação de uma transação, bloquear a realização de saques ou bloquear transações a qualquer momento, mesmo após a confirmação de pagamento de uma transação, independentemente de ter sido ou não aberta uma disputa pelos Usuários, nas seguintes situações, sem prejuízo de outras: (a) se a Empiria entender que há indícios de que o Usuário, o Encontro ou a transação estão em desacordo com os Termos Gerais de Uso da Empiria; (b) se a Empiria constatar que as informações relativas à transação são incompletas, inverídicas ou imprecisas; (c) se o Anfitrião não fornecer informações adequadas quando solicitado pela Empiria; (d) se a Empiria constatar que a transação expõe a risco excessivo aos Usuários ou à própria Empiria, devido às características da transação, do Encontro, dos volumes ou dos prazos de entrega; (e) se a Empiria observar que a adoção de qualquer uma dessas medidas é necessária para proteger a segurança da própria Empiria, seus empregados, colaboradores, representantes, agentes, sócios ou parceiros; (f) se a Empiria for envolvida em qualquer processo judicial ou administrativo relacionado a uma transação de pagamento e o Usuário não tomar as medidas necessárias para excluir a Empiria do referido processo, isentando-a de qualquer responsabilidade, conforme descrito nos Termos Gerais de Uso da Empiria e nesta Política; (g) se a Empiria tomar conhecimento de que o Usuário deixou de cumprir com as ordens de órgãos públicos; (h) em conformidade com qualquer exigência legal, decisão judicial ou determinação de autoridade pública competente dirigida à Empiria; (i) se a Empiria verificar a existência de valores vencidos e não pagos pelo Usuário.",
    },
    {
        tipo: "item",
        id: "6.4.",
        texto:
            "Bloqueios de recebimentos: Em qualquer das hipóteses previstas no parágrafo anterior, se você não sanar as informações relativas às transações, não prestar esclarecimentos satisfatórios ou não fornecer as garantias necessárias exigidas pela Empiria, esta poderá definitivamente recusar a aprovação da transação de pagamento, recusar a realização de uma transferência, bloquear qualquer recebimento ou até mesmo bloquear a sua conta na plataforma. A Empiria empregará os melhores esforços para cancelar os pagamentos ou movimentações correspondentes, bem como para estornar os valores aos Compradores, sem prejuízo da rescisão dos Serviços da Empiria e da aplicação de outras medidas cabíveis de acordo com os Termos da Empiria.",
    },
];

export default compraEPagamento;
